import { on } from "@ngrx/store";
import { ContractState } from "../contract.state";
import { ContractsActions } from "./contracts.actions";
import { ContractManagementActions } from "../../admin/contract-admin/contract-management/contract-management.actions";
import { UserActions } from "../../../user/user.actions";
import { PagesStore } from "../../pages.state";

// ============================================================================
// HELPER: Update contract state within PagesStore
// ============================================================================

function withContract(state: PagesStore, updater: (contract: ContractState) => ContractState): PagesStore {
    return { ...state, contract: updater(state.contract) };
}

// ============================================================================
// CONTRACTS LIST REDUCER (flattened structure)
// ============================================================================

const load = on(
    ContractsActions.load,
    (state: PagesStore) => withContract(state, contractState => ({
        ...contractState,
        loadingList: true,
    })),
);

// loadSuccess saves everything in one action
const loadSuccess = on(
    ContractsActions.loadSuccess,
    (state: PagesStore, { contracts, params }) => withContract(state, contractState => ({
        ...contractState,
        contracts,
        loaded: true,
        searchFilter: params.searchFilter,
        startDateFrom: params.startDateFrom,
        startDateTo: params.startDateTo,
        endDateFrom: params.endDateFrom,
        endDateTo: params.endDateTo,
        loadingList: false,
        error: null,
    })),
);

const loadFailure = on(
    ContractsActions.loadFailure,
    (state: PagesStore, { error }) => withContract(state, contractState => ({
        ...contractState,
        loadingList: false,
        error,
    })),
);

const invalidate = on(
    ContractsActions.invalidate,
    UserActions.changeCompanySuccess,
    (state: PagesStore) => withContract(state, contractState => ({
        ...contractState,
        loaded: false,
    })),
);

// ============================================================================
// HANDLE CONTRACT-ADMIN CRUD ACTIONS
// ============================================================================

const createContractSuccess = on(
    ContractManagementActions.createContractSuccess,
    (state: PagesStore, { contract }) => withContract(state, contractState => ({
        ...contractState,
        contracts: [...contractState.contracts, contract],
    })),
);

const deleteContractSuccess = on(
    ContractManagementActions.deleteContractSuccess,
    (state: PagesStore, { id }) => withContract(state, contractState => ({
        ...contractState,
        contracts: contractState.contracts.filter(c => c.id !== id),
    })),
);

export const contractsReducer = [
    load,
    loadSuccess,
    loadFailure,
    invalidate,
    createContractSuccess,
    deleteContractSuccess,
];
